import { EMPTY_LIST, EMPTY_STRING } from '../../../../../constants/common'
import { normalizeHtml } from '../../../../../utils/html'

function getRequestTranslatedTextValue(response) {
  return response?.data?.[0]?.translations?.[0]?.text ?? EMPTY_STRING
}

export function getRequestTranslationToolbarLanguageOptions(response) {
  const translationLanguages = response?.data?.translation

  if (!translationLanguages) {
    return EMPTY_LIST
  }

  return Object.entries(translationLanguages)
    .map(([value, languageItem]) => ({
      label: languageItem?.name || value,
      value,
    }))
    .sort((firstLanguageOption, secondLanguageOption) =>
      firstLanguageOption.label.localeCompare(secondLanguageOption.label)
    )
}

export function getRequestTranslationToolbarInitialLanguageOption({
  languageCode,
  languageOptions,
}) {
  return (
    languageOptions.find(
      languageOption => languageOption.value === languageCode
    ) || null
  )
}

export function getRequestTranslationToolbarHtmlValue(response) {
  const translatedTextValue = getRequestTranslatedTextValue(response)

  if (!translatedTextValue) {
    return EMPTY_STRING
  }

  // When MS Translator is called with textType=html it returns HTML markup.
  // Normalize it to match tinyMCE expectations.
  return normalizeHtml(translatedTextValue)
}
